// extracted by mini-css-extract-plugin
export var actionButton = "_84-1";
export var actionButtons = "_84-2";
export var actions = "_84-0";
export var aiUnread = "_84-10";
export var alignCenter = "_84-h";
export var backWrapper = "_84-3";
export var cellContainer = "_84-4";
export var checkboxContainer = "_84-5";
export var contentContainer = "_84-6";
export var contentHeader = "_84-8";
export var conversationsTableWrapper = "_84-s";
export var draftReplyBadgeContainer = "_84-m";
export var dropdownItem = "_84-b";
export var dropdownItemsContainer = "_84-a";
export var dropdownTitle = "_84-c";
export var errorIcon = "_84-7";
export var filter = "_84-d";
export var gray = "_84-i";
export var headerActionButtons = "_84-e";
export var headerCheckboxContainer = "_84-f";
export var icon = "_84-j";
export var menuContainer = "_84-k";
export var noMoreTicketsIcon = "_84-12";
export var noMoreTicketsSubText = "_84-13";
export var oneLine = "_84-l";
export var optionsButton = "_84-n";
export var plus = "_84-o";
export var portalButtonsWrapper = "_84-g";
export var red = "_84-p";
export var scrolledTop = "_84-9";
export var search = "_84-q";
export var selectedConversationsCount = "_84-r";
export var spinner = "_84-t";
export var strong = "_84-u";
export var summaryCell = "_84-v";
export var tableContainer = "_84-11";
export var tagContainer = "_84-w";
export var threeDots = "_84-x";
export var twoLines = "_84-y";
export var unread = "_84-z";